// Sign In states
import { signIn, signInConfig } from './signIn.js'

export default function signInRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(signIn, signInConfig)
}
